import { createFileRoute } from '@tanstack/react-router';
import {
  ContestEditReelsStep,
  validateReelsSearch,
} from '../pages/contests/edit/contest-edit-reels-step';

export const Route = createFileRoute('/contests/$id/edit/reels')({
  // `?reel=N` — the Reel the publish checklist's named options link to.
  validateSearch: validateReelsSearch,
  component: ContestEditReelsStep,
});
